// extracted by mini-css-extract-plugin
export default {"transcription-button":"TranscriptionButton_transcription-button__6EUH4"};